import InvoicesTableItem from './InvoicesTableItem';

export default InvoicesTableItem;
